import {
  FileText,
  Building,
  User,
  Calculator,
  CheckCircle,
  Edit3,
} from "lucide-react";

export const categories = [
  { id: "all", name: "All Categories", icon: FileText },
  { id: "corporate", name: "Corporate", icon: Building },
  { id: "tax", name: "Taxation", icon: Calculator },
  { id: "audit", name: "Audit", icon: CheckCircle },
  { id: "finance", name: "Finance", icon: User },
];

export const predefinedChecklists = [
  {
    id: "company-incorporation",
    slug: "company-incorporation",
    name: "Company Incorporation",
    category: "corporate",
    featured: true,
    items: [
      "PAU Card of Directors",
      "Aadhaar Card of Directors",
      "Passport size photographs",
      "Proof of registered office address",
      "Rental agreement/NOC from landlord",
      "Utility bills (electricity/water)",
      "MOA & AOA draft",
      "DIN applications for directors",
      "Bank account opening documents",
      "Professional tax registration",
    ],
  },
  {
    id: "gst-registration",
    slug: "gst-registration",
    name: "GST Registration",
    category: "tax",
    featured: true,
    items: [
      "PAN Card",
      "Aadhaar Card",
      "Business registration certificate",
      "Proof of business address",
      "Bank account statement",
      "Rental agreement (if applicable)",
      "Electricity bill",
      "Photographs of business premises",
      "Authorization letter (if applicable)",
      "Digital signature certificate",
    ],
  },
  {
    id: "income-tax-filing",
    slug: "income-tax-filing",
    name: "Income Tax Filing",
    category: "tax",
    items: [
      "Form 16/16A",
      "Salary certificates",
      "Bank statements",
      "Investment proofs (80C)",
      "Medical insurance receipts",
      "Home loan interest certificate",
      "Rent receipts",
      "Capital gains statements",
      "Other income documents",
      "Previous year ITR",
    ],
  },
  {
    id: "statutory-audit",
    slug: "statutory-audit",
    name: "Statutory Audit",
    category: "audit",
    items: [
      "Books of accounts",
      "Vouchers and supporting documents",
      "Bank statements and reconciliation",
      "Fixed assets register",
      "Inventory records",
      "Debtors and creditors confirmation",
      "Loan agreements and schedules",
      "Insurance policies",
      "Legal documents and agreements",
      "Previous year audit report",
    ],
  },
  // {
  //   id: "business-loan-application",
  //   slug: "business-loan-application",
  //   name: "Business Loan Application",
  //   category: "finance",
  //   items: [
  //     "Loan application form",
  //     "Business plan",
  //     "Financial statements (3 years)",
  //     "Bank statements (12 months)",
  //     "Income tax returns",
  //     "GST returns",
  //     "Property documents (collateral)",
  //     "KYC documents",
  //     "Business registration proof",
  //     "Existing loan details",
  //   ],
  // },
];
